export default {
  FOUR: '400',
  SIX: '600'
};
